import { render, staticRenderFns } from "./ChannelDecommissionForm.vue?vue&type=template&id=3cf3698e&scoped=true&"
import script from "./ChannelDecommissionForm.vue?vue&type=script&lang=js&"
export * from "./ChannelDecommissionForm.vue?vue&type=script&lang=js&"
import style0 from "./ChannelDecommissionForm.vue?vue&type=style&index=0&id=3cf3698e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3698e",
  null
  
)

export default component.exports